import React from 'react';
import { Link } from 'react-router-dom';
import placeholderImage from '../../assets/placeholder.png';
import styles from '../../styles/shared/CardGrid.module.css';
import { Store } from '../../types/store';
import componentStyles from './StoreCard.module.css';

interface StoreCardProps {
  store: Store;
  onDelete: (storeId: number) => void;
  onToggleActive?: (store: Store) => void;
}

const StoreCard: React.FC<StoreCardProps> = ({ store, onDelete, onToggleActive }) => {
  const handleDeleteClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onDelete(store.id);
  };

  return (
    <div className={`${styles.card} ${componentStyles.storeCard}`}>
      <div className={styles.imageContainer}>
        {store.image_url ? (
          <img
            src={store.image_url}
            alt={store.store_name}
            title={store.store_name}
            className={styles.cardImage}
            onError={(e) => {
              e.currentTarget.src = placeholderImage;
            }}
          />
        ) : (
          <div className={styles.placeholderImage} title={store.store_name}>🏪</div>
        )}
      </div>

      <div className={styles.cardContent}>
        <h3 className={styles.cardTitle} title={store.store_name}>{store.store_name}</h3>
        <span
          className={`${componentStyles.statusBadge} ${store.is_active ? componentStyles.statusActive : componentStyles.statusPending
            }`}
          title={store.is_active ? 'Active' : 'Pending'}
        >
          {store.is_active ? 'Active' : 'Pending'}
        </span>
        {store.store_description && (
          <p className={styles.cardDescription} title={store.store_description}>{store.store_description}</p>
        )}
        {store.subLocation?.location?.location_name && (
          <p className={componentStyles.locationText} title={`${store.subLocation.location.location_name}${store.subLocation.sub_location_name ? ` - ${store.subLocation.sub_location_name}` : ''}`}>
            {store.subLocation.location.location_name}
            {store.subLocation.sub_location_name && ` - ${store.subLocation.sub_location_name}`}
          </p>
        )}

        <div className={styles.cardActions}>
          {onToggleActive && (
            <button
              onClick={() => onToggleActive(store)}
              className={`${styles.cardActionButton} ${store.is_active ? styles.cardDisableButton : styles.cardEnableButton}`}
              title={store.is_active ? 'Disable Store' : 'Enable Store'}
            >
              {store.is_active ? 'Disable' : 'Enable'}
            </button>
          )}
          <Link
            to={`/store/${store.id}/overview`}
            className={`${styles.cardActionButton} ${styles.cardViewButton}`}
            title="View Store"
          >
            View
          </Link>
          <Link
            to={`/store/${store.id}/settings`}
            className={`${styles.cardActionButton} ${styles.cardEditButton}`}
            title="Edit Store"
          >
            Edit
          </Link>
          <button
            onClick={handleDeleteClick}
            className={`${styles.cardActionButton} ${styles.cardDeleteButton}`}
            title="Delete Store"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default StoreCard;
